import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import useCokitchenContext from 'contexts/cokitchen.context';
import { apiService } from 'services/base.service';
import PageText from 'components/base/page-text';
import FeedCard from 'components/feed-card';
import { CokitchenExploreKeywordType } from 'utils/types';

const PreviewFeeds = () => {
  const { category } = useDashboardContext();

  const { createCokitchenForm } = useCokitchenContext();
  const [loading, setLoading] = useState(false);
  const [feeds, setFeeds] = useState<CokitchenExploreKeywordType[]>([]);
  const [selectedFeeds, setSelectedFeeds] = useState<CokitchenExploreKeywordType[]>([]);
  useEffect(() => {
    getFeeds();
  }, [category]);
  const getFeeds = async () => {
    try {
      setLoading(true);
      const res = await apiService.post('cokitchen-explore-keyword-new', {
        data: {
          item_type: 'FOOD'
        },
        isInternal: true
      });
      if (res?.data) {
        setFeeds(res?.data?.data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (createCokitchenForm.cokitchen_explore_ids.length > 0) {
      setSelectedFeeds(
        feeds.filter((feed) => createCokitchenForm.cokitchen_explore_ids.includes(feed.id))
      );
    }
  }, [feeds]);
  return (
    <div>
      {loading ? (
        <PageText text='Loading...' />
      ) : selectedFeeds.length === 0 ? (
        <PageText text='No feeds found' />
      ) : (
        <div className='grid gap-4 md:grid-cols-3 lg:grid-cols-4'>
          {selectedFeeds
            ?.sort((a, b) => b.updated_at.localeCompare(a.updated_at))
            ?.map((feed) => (
              <FeedCard key={feed.id} image={feed?.meal_keyword?.images?.[0] || ''}>
                <p className='text-sm'>{feed?.meal_keyword?.name}</p>
              </FeedCard>
            ))}
        </div>
      )}
    </div>
  );
};

export default PreviewFeeds;
